import { styled } from "styled-components";
import { TabsContainer } from "../../Farm/TabsSelector";

export const MainWrapper = styled.div`
  position: relative;
  align-items: flex-start;
  gap: 20px;
  @media screen and (max-width: 1023px) {
    flex-direction: column;
  }
`;

export const BlockLeft = styled.div`
  position: relative;
  width: calc(100% - 570px);
  transition: all 0.2s linear;
  gap: 20px;
  flex-direction: column;
  &.light {
    background: #ffffff;
    border-color: #b8b8c1;
  }
  @media screen and (max-width: 1023px) {
    width: 100%;
  }
`;

export const BlockChart = styled.div`
  position: relative;
  min-height: 200px;
  border-radius: 12px;
  border: 1px solid #4d4d57;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`;

export const TitleChart = styled.div`
  position: relative;
  padding: 15px 20px;
  box-sizing: border-box;
  h1 {
    color: var(--Stake-Title, #fff);
    font-size: 24px;
    font-style: normal;
    font-family: Dirtyline;
    font-weight: 400;
    line-height: 96%;
    text-transform: lowercase;
  }
  p {
    color: var(--Neutral-300, #b8b8c1);
    font-family: Syne;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-top: 3px;
  }
`;

export const PairTokens = styled.div`
  position: relative;
  gap: 8px;
  p {
    color: #fff;
    font-family: DMMono-500;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
  }
  .dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 4px;
  }
`;

export const ShowChart = styled.div`
  position: relative;
`;

export const FooterChart = styled.div`
  position: relative;
  background: #1c1c1e;
  padding: 10px 20px 0px;
  box-sizing: border-box;
  h2 {
    color: #fff;
    font-family: DMMono-500;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
  }
  h1 {
    font-family: DMMono-500;
    font-size: 20px;
    font-style: normal;
    line-height: 125%;
    padding-right: 20px;
  }
`;

export const FooterChartItem = styled.div`
  border-radius: 10.12px;
  background: #28272c;
  padding: 12px;
  margin-top: 10px;
  margin-bottom: 20px;
  margin-right: 20px;
  min-width: calc((100% - 100px) / 2);
  h3 {
    font-family: DMMono-500;
    font-size: 16px;
    font-style: normal;
    line-height: 125%;
  }
  p {
    font-family: DMMono-400;
    font-size: 14px;
    font-style: normal;
    line-height: 125%;
    text-align: left;
  }

  .img-token {
    max-width: 32px;
    margin-right: 4px;
    img {
      width: 100%;
    }
  }
`;

export const BlockReward = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  background: #1c1c1e;
  box-shadow: 0px 0px 85px 0px rgba(106, 126, 228, 0.15);
  backdrop-filter: blur(122px);
  border: 1px solid #4d4d57;
  border-radius: 12px;
`;

export const ContentsReward = styled.div`
  position: relative;
  background: #29282e;
  padding: 15px;
  margin-top: 10px;
  border-radius: 12px;
`;

export const RowContents = styled.div`
  position: relative;
  margin: 5px 0;
  p {
    color: var(--Neutral-300, #b8b8c1);
    font-family: Syne;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
  h1 {
    font-family: Syne;
    font-size: 16px;
    font-style: normal;
  }
  .img-token {
    max-width: 24px;
    margin-right: 4px;
    img {
      width: 100%;
    }
  }
  &.remove {
    flex-direction: column;
    justify-content: flex-start;
    align-items: unset;
    .remove-receive {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      & > div {
        display: flex;
        align-items: center;
        p {
          font-family: DMMono-500;
          font-size: 24px;
        }
      }
      h1 {
        margin-bottom: 0;
      }
    }
  }
`;

export const BlockRight = styled.div`
  position: relative;
  max-width: 550px;
  width: 100%;
  position: relative;
  padding: 20px 15px;
  border-radius: 12px;
  border: 1px solid #4d4d57;
  background: #1c1c1e;
  box-shadow: 0px 0px 85px 0px rgba(106, 126, 228, 0.15);
  overflow: hidden;
  h1 {
    color: var(--Stake-Title, #fff);
    font-size: 24px;
    font-style: normal;
    font-family: Dirtyline;
    font-weight: 400;
    line-height: 96%;
    text-transform: lowercase;
    margin-bottom: 10px;
  }
  .block-header {
    display: flex;
    justify-content: space-between;
    figure {
      width: 20px;
      height: 20px;
      cursor: pointer;
      transition: all 0.25s linear;
      &:hover {
        opacity: 0.75;
      }
      img {
        width: 100%;
      }
    }
  }
  ${TabsContainer} {
    margin-bottom: 20px;
  }
  @media screen and (max-width: 1023px) {
    width: calc(100% - 32px);
    max-width: unset;
  }
`;
export const WrapChooseShape = styled.div`
  position: relative;
  margin-top: 20px;
  margin-bottom: 10px;
  h1 {
    color: var(--Stake-Title, #fff);
    font-size: 20px;
    font-style: normal;
    font-family: Dirtyline;
    font-weight: 400;
    line-height: 96%;
    text-transform: lowercase;
    margin-bottom: 5px;
  }
`;

export const ChooseShape = styled.div`
  position: relative;
  gap: 5px;
`;

export const ChooseShapeItem = styled.div`
  position: relative;
  max-width: calc((100% - 8) / 3);
  border-radius: 6px;
  border: 1px solid #4d4d57;
  flex-direction: column;
  gap: 4px;
  transition: all.3s;
  cursor: pointer;
  .img-shape {
    max-width: 180px;
    img {
      width: 100%;
    }
  }
  p {
    color: var(--Stake-Title, #fff);
    font-size: 14px;
    font-style: normal;
    font-family: Dirtyline;
    font-weight: 400;
    line-height: 96%;
    text-transform: lowercase;
  }
`;

export const SelectPrice = styled.div`
  position: relative;
`;

export const ItemPrice = styled.div`
  position: relative;
  max-width: 60%;
  width: 100%;
`;

export const WrapRange = styled.div`
  position: relative;
`;

export const ActiveBin = styled.div`
  position: relative;
  padding: 10px 20px;
  border-radius: 16px;
  background-color: var(--tabsBtn, #43424a);
  max-width: 80%;
  margin: 10px auto;
  p {
    color: var(--Stake-Title, #fff);
    font-size: 14px;
    font-style: normal;
    font-family: DMMono-400;
    font-weight: 400;
    line-height: 96%;
    text-align: center;
  }
`;

export const WrapSliderPrice = styled.div`
  position: relative;
  margin-top: 20px;
  .line {
    width: 3px;
    height: 20px;
    background-color: #fff;
    position: absolute;
    top: -4px;
    left: 50%;
    margin-left: -1.5px;
    z-index: 2;
  }
  .custom-slider {
    background-color: #43424a;
    border-radius: 8px;
    .ant-slider-track {
      height: 12px;
      background-color: rgba(232, 66, 67, 0.8);
      border-radius: 8px;
      margin-top: -4px;
    }
    .ant-slider-handle {
      z-index: 5;
      &::after {
        background-color: #43424a;
        box-shadow: 0 0 0 2px #fff;
      }
    }
  }
`;

export const WrapPrice = styled.div`
  position: relative;
  gap: 5px;
  margin-top: 10px;
`;

export const InfoPrice = styled.div`
  position: relative;
  width: calc((100% - 10px) / 2.5);
  box-sizing: border-box;
  p {
    color: var(--Stake-Title, #fff);
    font-size: 14px;
    font-style: normal;
    font-family: DMMono-400;
    font-weight: 400;
    margin-bottom: 5px;
  }
  input {
    border: none;
    outline: none;
    background: transparent;
    color: var(--Stake-Title, #fff);
    font-size: 14px;
    font-style: normal;
    font-family: DMMono-500;
    font-weight: 500;
    margin: 0;
    max-width: 60%;
  }
  &:nth-child(3) {
    max-width: 100px;
  }
`;

export const InputPrice = styled.div`
  border-radius: 12px;
  border: 1px solid #4d4d57;
  padding: 10px 5px;
  gap: 4px;
  box-sizing: border-box;
  h1 {
    color: var(--Stake-Title, #fff);
    font-size: 14px;
    font-style: normal;
    font-family: DMMono-500;
    font-weight: 500;
    margin: 0;
  }
  h2 {
    color: var(--Stake-Title, #fff);
    font-size: 12px;
    font-style: normal;
    font-family: DMMono-400;
    font-weight: 400;
    white-space: nowrap;
    border-left: 1px solid #fff;
    padding-left: 5px;
  }
`;

export const WrapActions = styled.div`
  position: relative;
  gap: 20px;
  margin-bottom: 10px;
  h1 {
    color: #e84142;
    font-size: 14px;
    font-style: normal;
    font-family: Syne;
    font-weight: 500;
    margin: 0;
    cursor: pointer;
    text-transform: unset;
    transition: all 0.2s linear;
    &:nth-child(1) {
      color: #fff;
    }
    &:hover {
      opacity: 0.45;
    }
  }
`;

export const WrapChooseShapeV2 = styled.div`
  position: relative;
  margin-top: 20px;
  margin-bottom: 10px;
  ${InfoPrice} {
    width: calc((100% - 10px) / 2);
    input {
      max-width: 70%;
    }
  }
`;

export const TextNoDataLiquidity = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
`